import React, { Component } from 'react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { withRouter } from "react-router-dom";
import moment from 'moment'
import config from 'react-global-configuration';

class InvoiceTable extends Component {

  constructor(props) {
      super(props)
      this.state = {
          data: this.props.data,
      }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data)
      this.setState({ data: this.props.data })
  }

  sortDates = (a, b, order) => {
    let indices = [6, 7, 8, 9, 3, 4, 0, 1];
    if (order === 'asc') {
      let r = 0;
      indices.find(i => r = a.date.charCodeAt(i) - b.date.charCodeAt(i));
      return r;
    } else if (order === 'desc') {
      let r = 0;
      indices.find(i => r = b.date.toString().charCodeAt(i) - a.date.toString().charCodeAt(i));
      return r;
    }
  }

  sortInvoiceNumbers = (a, b, order) => {
    const a_parts = a.invoiceNumber ? a.invoiceNumber.split("-") : [0,0]
    const a_year = Number(a_parts[a_parts.length-2])
    const a_number = Number(a_parts[a_parts.length-1])

    const b_parts = b.invoiceNumber ? b.invoiceNumber.split("-") : [0,0]
    const b_year = Number(b_parts[b_parts.length-2])
    const b_number = Number(b_parts[b_parts.length-1])

    if (order === 'asc') {
      return (a_year - b_year)*100000 + ( a_number - b_number );
    } else if (order === 'desc') {
      return (b_year - a_year)*100000 + ( b_number - a_number );
    }
  }

  onRowClick = row => {
    if(this.props.onRowClick === "details")
      this.props.history.push(`/internal/admin/invoices/${row.objectId}`);
  }

  addContractLink = (cell, row) => {
    return (<div><a href={cell} target="_blank" style={{cursor: "pointer"}}>Anzeigen</a></div>);
  }

  render() {
    const invoices = this.state.data;
    const hidden = this.props.hide ? this.props.hide : [];


    if(!(invoices != null && invoices.length > 0))
      return <p style={{color: "#000000"}}>Keine Rechnungen</p>

    let invoiceItems = []

    invoices.map((invoice, idx) =>
      invoiceItems.push({
        objectId: invoice.objectId,
        invoiceNumber: invoice.invoiceNumber,
        paid: invoice.isPaid ? "Bezahlt ✔" : "Zahlung ausstehend ✘",
        status: !invoice.gotRefunded ? ( invoice.isRefund ? "Stornorechnung" : invoice.isPaid ? "Bezahlt ✔" : "Zahlung ausstehend ✘") : "Storniert ✘",
        contract: invoice.contract && invoice.contract.objectId,
        year: invoice.contract && invoice.contract.year,
        date: moment(invoice.createdAt).locale("en").format('DD/MM/YYYY'),
        value: "€ " + invoice.amount,
        link: config.get('CLOUDINARY_URL') + invoice.url,
        type: invoice.isRefund ? "Gutschrift" : "Lastschrift",
        company: invoice.contract && invoice.contract.company ? invoice.contract.company.name : "-",
      })
    )

    return (
      <div>
        <BootstrapTable data={ invoiceItems } borderless={true} options={{ onRowClick: this.onRowClick, defaultSortName: 'invoiceNumber', defaultSortOrder: 'desc' }} hover pagination={this.props.pagination} search={this.props.search} bodyStyle={{cursor: this.props.onRowClick ? "pointer" : ""}}>
            <TableHeaderColumn dataField="invoiceNumber" dataSort={true} isKey sortFunc={this.sortInvoiceNumbers}>Rechnungsnr.</TableHeaderColumn>
          { !hidden.includes("contract") &&
            <TableHeaderColumn dataField="contract">Vertrags ID</TableHeaderColumn> }
          { !hidden.includes("company") &&
            <TableHeaderColumn dataField="company" dataSort={true}>Firma</TableHeaderColumn> }
          { /*!hidden.includes("year") &&
            <TableHeaderColumn dataField="year" dataSort={true}>Jahr</TableHeaderColumn> */}
          { !hidden.includes("date") &&
            <TableHeaderColumn dataField="date" dataSort={true} sortFunc={this.sortDates}>Datum</TableHeaderColumn> }
          { !hidden.includes("type") &&
            <TableHeaderColumn dataField="type" dataSort={true}>Rechnungstyp</TableHeaderColumn> }
          { !hidden.includes("value") &&
            <TableHeaderColumn dataField="value" dataSort={true}>Betrag</TableHeaderColumn> }
          { !hidden.includes("paid") &&
            <TableHeaderColumn dataField="status" dataSort={true}>Status</TableHeaderColumn> }
          { !hidden.includes("link") &&
            <TableHeaderColumn dataField="link" dataFormat={this.addContractLink}>Rechnung</TableHeaderColumn> }
        </BootstrapTable>
      </div>
    )
  }
}

export default withRouter(InvoiceTable)



// WEBPACK FOOTER //
// /src/components/Tables/InvoiceTable.js